/** The kinds of the system Contacts template (slug contact_default), which holds persons and companies alike. */
export const ContactKindValue = {
  PERSON: "person",
  COMPANY: "company",
} as const;

export type ContactKindValue = (typeof ContactKindValue)[keyof typeof ContactKindValue];
